import type { ResultListCheckProps } from './types';
import Checkbox from '../../../../Checkbox';

const ResultListCheck = ({
  option,
  handleChange,
  handleCheckedOption,
}: ResultListCheckProps) => {
  return (
    <>
      <Checkbox
        label={option?.label}
        onChange={() => handleChange(option)}
        checked={handleCheckedOption(option)}
      />
      {option.content}
    </>
  );
};

export default ResultListCheck;
